// extracted by mini-css-extract-plugin
export default {"control":"NavbarLinksGroup_control__ruFqp","link":"NavbarLinksGroup_link__cHian","chevron":"NavbarLinksGroup_chevron__7rv3T","nav_active":"NavbarLinksGroup_nav_active__JLsYa"};